import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  max-width: 460px;
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
  background-color: ${({ theme, $white }) =>
    $white ? theme.colors.grey.white : theme.colors.grey[800]};
  color: ${({ theme, $white }) =>
    $white ? theme.colors.grey.black : theme.colors.grey.white};
  border-radius: 12px;
`;

export const Close = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    background-color: transparent;
    border: 0;
    color: ${({ theme, $white }) =>
      $white ? theme.colors.grey.black : theme.colors.grey.white};
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  h3 {
    text-transform: uppercase;
    font-family: 'Anton', sans-serif;
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 12px;

  p {
    text-align: justify;

    b {
      font-weight: 700;
    }
  }

  a {
    font-size: 20px;
    color: ${({ theme }) => theme.colors.primary.main};
    text-decoration: underline;
    font-weight: 700;
  }
`;
